// extracted by mini-css-extract-plugin
module.exports = {"projectDisplay":"ProjectDisplay_projectDisplay__29Tzn","darkTheme":"ProjectDisplay_darkTheme__1zy-w","lightTheme":"ProjectDisplay_lightTheme__2u8zI"};